// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info-wrapper[data-v-04920302]{flex:0 0 450px}@media screen and (max-width:767px){.info-wrapper[data-v-04920302]{flex:1 1 auto}}.info[data-v-04920302]{opacity:0;visibility:hidden;display:none}.info[data-v-04920302],.info.active[data-v-04920302]{transition:all .3s ease-in-out}.info.active[data-v-04920302]{opacity:1;visibility:visible;display:block}.title[data-v-04920302]{max-width:400px}.toggler[data-v-04920302]{cursor:pointer;font-size:3rem}", ""]);
// Exports
module.exports = exports;
